/**
 * PrivateRoute — React Router v6 auth guard.
 *
 * Renders the nested `<Outlet>` when the user is authenticated.
 * Redirects to `/` (Login) otherwise.
 */
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoutes = () => {
  const { isAuthenticated } = useSelector(({ auth }) => auth);

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoutes;
